<template>
    <div
        class="prize-container-item"
    >
        <flow-container :children='tpl.children'></flow-container>
    </div>
</template>

<script>
const {
    plugins: { ComplexComp },
} = require("@futuweb/fego-render");

export default {
    props: ['tpl'],

    components: {
        FlowContainer: ComplexComp.Container.Flow,
    }
};
</script>

<style lang="less" scoped>
.prize-container-item {
    display: flex;
    height: 100% !important;
    align-items: center;
    justify-content: center;
}
</style>
